import { render } from "./EmptyLayout.vue?vue&type=template&id=52f253b2&scoped=true"
import script from "./EmptyLayout.vue?vue&type=script&lang=js"
export * from "./EmptyLayout.vue?vue&type=script&lang=js"

import "./EmptyLayout.vue?vue&type=style&index=0&id=52f253b2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52f253b2"]])

export default __exports__